import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { loaderSelector } from '../../redux/selectors/loader';
import FullLoader from './FullLoader';

const mapStateToProps = createStructuredSelector({
  loader: loaderSelector(),
});
const FullScreenLoader = ({ loader }: { loader?: boolean }) => {
  if (!loader) {
    return null;
  }
  return <FullLoader />;
};

export default connect(mapStateToProps, null)(FullScreenLoader);
